'use client';

import { usePathname, useRouter } from '@/i18n/routing';
import { Search } from 'lucide-react';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import { useDebouncedCallback } from 'use-debounce';

const SearchQuery = ({ queryName, placeholder }: { queryName: string; placeholder?: string }) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const handleSearch = useDebouncedCallback((term: string) => {
    const params = new URLSearchParams(searchParams);
    // params.set('page', '1');
    if (queryName && term) {
      params.set(queryName, term);
    } else {
      params.delete(queryName);
    }
    replace(`${pathname}?${params.toString()}`);
  }, 300);

  return (
    <div className="w-full">
      <div className="relative">
        <div className="trl:right-0 absolute inset-y-0 flex cursor-pointer items-center ltr:left-0 ltr:pl-3 rtl:pr-3">
          <Search className="h-5 w-5 text-gray-200" />
        </div>
        <input
          type="text"
          placeholder={placeholder ?? 'Search something here'}
          defaultValue={searchParams.get(queryName)?.toString()}
          onChange={(e) => handleSearch(e.target.value)}
          className="border-secondary placeholder:text-gray-250 focus:ring-primary w-full rounded-xl border px-10 py-2 shadow-xs focus:ring-2 focus:outline-hidden"
        />
      </div>
    </div>
  );
};

export default SearchQuery;
